import baseUrl from '../utils/baseUrl'
import axios from './api'

const getAll = async () => await axios.get(baseUrl + `/mechanic-notification/all`).then((response) => response.data)

const approve = async (body) => {
    return await axios.post(baseUrl + `/mechanic-notification/approve`, body).then((response) => response.data)
}

const deny = async (body) => {
    return await axios.post(baseUrl + `/mechanic-notification/deny`, body).then((response) => response.data)
}

const deleteNotification = async (id) => {
    return await axios.delete(baseUrl + `/mechanic-notification/${id}`)
}

export { getAll, approve, deny, deleteNotification }
